import React from 'react';

import SVGIcon, { GENERAL_ICONS } from 'src/components/svg';

import { lang, remCss } from 'src/helpers';
import { MCButton } from 'src/components/basic';

export class CookiePolicy extends React.PureComponent {
  state = { innerWidth: 0 };
  componentDidMount() {
    window.addEventListener('resize', this.updateWidthWindow);
    this.updateWidthWindow();
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.updateWidthWindow);
  }

  updateWidthWindow = () => {
    const innerWidth = window.innerWidth;
    this.setState({ innerWidth });
  };

  isRotate = () => {
    return this.state.innerWidth < 800;
  };
  render() {
    const { hide, actions } = this.props;

    if (this.isRotate()) {
      return (
        <div className={'mc-popup-contain'}>
          <div className={'mc-flex-15-col'}>
            <div className={'mc-flex'}>
              <div className={'mc-value-636'}>{lang.t('We use Cookies')}</div>
              <SVGIcon iconname={GENERAL_ICONS.COOKIE} width={30} height={30} />
            </div>
            <pre className={'mc-note-416'}>
              {lang.t(
                'We waited to make sure that you were interested in the content of this website before bothering you, but we would love to be your companions during your visit...\n' +
                  '\n' +
                  'Is that OK with you?'
              )}
            </pre>
            <div className={'mc-flex'}>
              <MCButton
                dark
                primary
                radius
                large
                onClick={() => {
                  actions.ok();
                  hide();
                }}
                style={{ width: remCss(180) }}
              >
                {lang.t('Sweet!')}
              </MCButton>
              <MCButton
                light
                primary
                radius
                large
                onClick={() => {
                  actions.cancel();
                  hide();
                }}
                style={{ width: remCss(180) }}
              >
                {lang.t('Cancel')}
              </MCButton>
            </div>
          </div>
        </div>
      );
    }

    return (
      <div className={'mc-popup-contain'}>
        <div className={'mc-flex-15 mc-p25'}>
          <div>
            <SVGIcon iconname={GENERAL_ICONS.COOKIE} />
          </div>
          <div className={'mc-content'}>
            <div className={'mc-flex-15-col'}>
              <div className={'mc-value-636'}>{lang.t('We use Cookies')}</div>
              <pre className={'mc-note-416'}>
                {lang.t(
                  'We waited to make sure that you were interested in the content of this website before bothering you, but we would love to be your companions during your visit...\n' +
                    '\n' +
                    'Is that OK with you?'
                )}
              </pre>
            </div>
            <div className={'mc-flex'}>
              <MCButton
                dark
                primary
                radius
                large
                onClick={() => {
                  actions.ok();
                  hide();
                }}
                style={{ width: remCss(180) }}
              >
                {lang.t('Sweet!')}
              </MCButton>
              <MCButton
                light
                primary
                radius
                large
                onClick={() => {
                  actions.cancel();
                  hide();
                }}
                style={{ width: remCss(180) }}
              >
                {lang.t('Cancel')}
              </MCButton>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
